<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<div class="mdc-layout-grid" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'" *ngIf="!loading">
	<div class="mdc-layout-grid__inner">
		<div class="mdc-layout-grid__cell--span-12" *ngIf="!embedded">
			<app-navigation *ngIf="header.toggleHeader$ | async"></app-navigation>
		</div>

		<div
			class="mdc-layout-grid__cell--span-12"
			[ngClass]="{ router: !embedded, 'payment-tier-screen': increaseMaxWidth, 'ads-screen': increaseMaxWidthofAds }"
		>
			<router-outlet></router-outlet>
		</div>
	</div>
</div>

<div class="row mx-0 bg-lightest-grey footer p-4" *ngIf="!loading && !embedded && viewport.showFooter">
	<div class="col-12 px-0" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
		<app-footer></app-footer>
	</div>
</div>
